import React from "react";
import { useTranslation } from "react-i18next";

const SearchCount = ({ count }) => {
    const { t } = useTranslation();

    return (
        <p className="data-table__search-results">
            {t("searchCount")} ({count})
        </p>
    );
};

export default SearchCount;
